export default __webpack_public_path__ + "static/media/oslo-policy-summary.11737da1.pdf";